import React from 'react';

import * as E from 'fp-ts/Either';
import { pipe } from 'fp-ts/lib/function';
import * as T from 'fp-ts/Task';
import * as TE from 'fp-ts/TaskEither';
import { useAtom } from 'jotai';

import NextButton from './buttons/NextButton';
import { Iframe } from './Iframe';

import AuthApi from '../api/AuthApi';
import { agreementState } from '../model/state/agreementState';
import { useError } from '../model/state/errorState';
import { executeTask } from '../util/bs-fp';

export const Agreement: React.FC = () => {
  const [agreement, setAgreement] = useAtom(agreementState);

  const setToast = useError(true);

  const onAcceptAgreementError = () => {};
  const onAcceptAgreementOk = () => {
    setAgreement(undefined);
  };

  const sendAcceptAgreementRequestTask = () =>
    pipe(
      AuthApi.acceptAgreement(),
      TE.mapLeft(setToast),
      T.map(E.fold(onAcceptAgreementError, onAcceptAgreementOk))
    );

  return (
    <>
      {agreement && (
        <div className="absolute left-0 top-0 z-50 flex h-full w-full overflow-y-hidden bg-[rgba(255,255,255,0.5)]">
          <div className="flex flex-1 flex-col items-center justify-between gap-8 overflow-hidden rounded-[15px] bg-white px-4 sm:mx-[5%] sm:my-4">
            <div className="mt-4 flex h-full w-full flex-col justify-between overflow-hidden bg-[hsla(0,0%,49.3%,0.38)]">
              <div className="flex h-full overflow-hidden">
                <Iframe frameBorder="0" scrolling="yes" className="frame" src={agreement} />
              </div>
            </div>
            <div className="pointer-events-auto mx-[5%] flex w-full items-center justify-center pb-8">
              <div className="w-[280px] lg:w-[444px]">
                <NextButton
                  buttonRounded
                  text="Got it"
                  onClick={async () => {
                    const task = sendAcceptAgreementRequestTask();
                    await executeTask(task);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
